import './index.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '../../../actions/app-actions-types';
import {
  convertToDollars,
  formatPrizeNumber,
  formattedWinningsPerPosition,
  getIstWinner,
  getLeaderBoardTypeData,
  getLowestWinningsRank,
  isGadgetLeague,
  isMatchInScheduled
} from '../../../utilities/helper';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import Constants from '../../../constants';
import useGame from '../../../utilities/hooks/game';
import { View, Text, Card } from '../../../component';
import { useLink } from 'react-router-stack';
import React from 'react';
import constants from '../../../constants';

interface LeagueTypeProps {
  istWinner?: any;
  isSingleEntry?: boolean;
  isMultiEntry?: boolean;
  isH2HLeague?: boolean;
  isConfirmed?: boolean;
  theme?: any;
  bonusPercentage?: number;
  minimumPlayers?: number;
  isShowMinimumTeams?: boolean;
  isGadgetLeague?: boolean;
}

const LeagueType = ({
  isSingleEntry,
  isMultiEntry,
  istWinner,
  theme,

  isGadgetLeague = false
}: LeagueTypeProps) => {
  const leagueTypeTitle = {
    color: 'white'
  };

  const istWinnerValue = `₹${formatPrizeNumber(istWinner)}`;
  const iconDimensions = 16;

  return (
    <View className="league-type-container">
      <View className="league-type-container">
        {!isGadgetLeague && (
          <View className="league-type-title-container" style={{ marginLeft: 0 }}>
            <Constants.Svgs.FirstPrize />
            <Text className="league-type-title" style={leagueTypeTitle}>{`${istWinnerValue}`}</Text>
          </View>
        )}

        {isSingleEntry && (
          <>
            <View className="contest-card-vertical-divider"></View>
            <View className="league-type-title-container">
              <Constants.Svgs.SingleEntryLeague
                width={iconDimensions}
                fillPrimary={theme.contestCardSingleEntryIconPrimary}
                fillSecondary={theme.contestCardSingleEntryIconSecondary}
              />

              <Text className="league-type-title" style={leagueTypeTitle}>
                {'Single'}
              </Text>
            </View>
          </>
        )}

        {isMultiEntry && (
          <>
            <View className="contest-card-vertical-divider"></View>
            <View className="league-type-title-container">
              <img src={constants.Images.multiple} width={'90px'} />
              <Text className="league-type-title" style={leagueTypeTitle}>
                {'Multiple'}
              </Text>
            </View>
          </>
        )}
      </View>
    </View>
  );
};

interface ContestCardProps {
  onPressCard: any;
  contest: any;
  onPressShare?: any;
  matchStatus: any;
  isContestDetails: any;
  gameState: any;
  matchItem: any;
  totalTeamsCount: number;
  screenName: any;
  matchDelayed: boolean;
  gameType: any;
  onPressJoin?: any;
}

const ContestCardWeb = ({
  onPressCard,
  contest,
  // onPressShare,
  matchStatus,
  isContestDetails = false,
  gameState,
  matchItem,
  onPressJoin,
  matchDelayed = false,
  gameType = ''
}: ContestCardProps) => {
  const navigate = useLink();
  const { FantasyTheme: theme } = useTheme();
  let { themeType = '' } = useSelector((state: any) => state.setting);
  const { contestTypes = [], fantasyMatchClick } = useGame();
  const [formatWinning, setFormatWinnings] = useState({});
  const [noOfWinner, setNoOfWinner] = useState(0);
  const dispatch = useDispatch();

  const {
    maximumPlayers = 2,
    minimumPlayers = 0,
    winningsAmount = 0,
    entryFee = 0,
    bonusPercentage = 0,
    isConfirmed,
    winningsPerPosition = {},
    filledTeamSlots = 0,
    contestTypeId = '',
    title = '',
    contestCategoryId = ''
  } = contest;

  const { matchTitle = '', startDate = '' } = matchItem;
  const isGadgetLeague_ = isGadgetLeague(title);

  const { isGL, isSL, isShowLeaderboard, isWeeklyGL } = React.useMemo(() => {
    return getLeaderBoardTypeData(contestCategoryId, matchTitle, entryFee, startDate, gameType);
  }, [contestCategoryId, matchTitle, entryFee, startDate, gameType]);

  let contestType: any = {};
  if (contestTypes[contestTypeId]) {
    contestType = contestTypes[contestTypeId];
  }

  useEffect(() => {
    formattedWinningsPerPosition(winningsPerPosition);
    setFormatWinnings(formattedWinningsPerPosition(winningsPerPosition));
    const lowestWinningRank = getLowestWinningsRank(winningsPerPosition);
    setNoOfWinner(lowestWinningRank);
  }, [winningsPerPosition, maximumPlayers]);

  let { maxTeamPerUser = 0 } = contest;
  const { slug: contestGroupTitle = '', acceptsMultipleEntry = false } = contestType;
  if (
    (maxTeamPerUser === 0 && contestGroupTitle === 'head_to_head') ||
    contestGroupTitle === 'multiple_player_one_entry'
  ) {
    maxTeamPerUser = 1;
  } else if (maxTeamPerUser === 0 && contestGroupTitle === 'multiple_player_multiple_entry') {
    maxTeamPerUser = 11;
  }

  const isFilled = filledTeamSlots === maximumPlayers ? true : false;

  let progressPercentage: any = 0;
  if (maximumPlayers !== 0) {
    progressPercentage = Math.ceil((filledTeamSlots / maximumPlayers) * 100).toString();
  }
  progressPercentage = `${progressPercentage}%`;

  const contestCardContainerColor = {
    background: theme.contestCardContainer,
    boxShadow: theme.contestCardBoxShadow,
    border: themeType === 'dark' ? '' : `2px solid ${theme.contestCardBorder}`
  };
  const boldTextColor = {
    color: theme.contestCardWinningText
  };

  const boldText1Color = {
    color: theme.contestCardEntryFeeText
  };

  const entryFeeWrapperColor = {
    backgroundColor: theme.contestCardEntryFeeWrapper,
    borderColor: theme.contestCardEntryFeeWrapperBorder
  };

  const progressWrapperColor = {
    backgroundColor: theme.contestCardTeamProgress
  };

  const currentProgressColor = {
    backgroundColor: theme.contestCardTeamCurrentProgress
  };

  const totalWinnersColor = {
    color: theme.contestCardTotalWinners
  };

  const fillTeamSlotsColor = {
    color: theme.contestCardFillTeamSlots
  };

  const totalSlotsColor = {
    color: theme.contestCardTotalSlots
  };

  // const shareAndEarn = {
  //   color: theme.contestCardUpToBonus
  // };

  // const shareContainer = {
  //   borderColor: theme.contestCardShareBorder
  // };

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });

  const onPressPlayButton = () => {
    if (!isFilled && isMatchScheduled) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            contest
          }
        })
      );

      if (gameType !== constants.GameType.FANTASY_YES_NO) {
        navigate.push('/my_teams');
      } else {
        onPressJoin();
      }
    } else {
      dispatch(showToast(I18n.t('contestAlreadyFilledMsg')));
    }
  };

  const onPressLeaderBoard = () => {
    navigate.push('/leaderboard', {
      type: isGL ? 'GL' : 'SL'
    });
  };

  const onPressWeekly = () => {
    navigate.push('/monthly_leaderboard');
  };

  const _onPressCard = (event: any) => {
    event.stopPropagation();
    onPressCard();
  };
  // const _onPressShare = (event: any) => {
  //   event.stopPropagation();
  //   onPressShare();
  // };
  const _onPressPlayButton = (event: any) => {
    event.stopPropagation();
    // navigate.push('/my_teams');
    onPressPlayButton();
  };

  const SLStyle = {
    backgroundColor: theme.contestCardSLBG
  };

  const WLStyle = {
    marginRight: '10px',
    backgroundColor: theme.contestCardWLBG
  };

  const GLStyle = {
    backgroundColor: theme.contestCardGLBG
  };

  const SLTitleStyle = {
    color: theme.contestCardSLTitle
  };

  const WLTitleStyle = {
    color: theme.contestCardWLTitle
  };

  const GLLTitleStyle = {
    color: theme.contestCardGLTitle
  };
  const contestCardTopSectionStyle = {
    borderBottom: themeType === 'dark' ? '' : `2px solid ${theme.contestCardBorder}`,
    background: theme.contestCardTopSectionBg,
    boxShadow: theme.contestCardTopSectionBoxShadow
  };

  return (
    <View
      style={{
        marginTop: isContestDetails ? '10px ' : '0px'
      }}>
      {isShowLeaderboard && (
        <View className="contest-card-strip-wrapper">
          <View className="contest-card-strip-sub-wrapper">
            {isWeeklyGL && (
              <View style={WLStyle} onPress={onPressWeekly} className="contest-card-strip-gl">
                <Text style={WLTitleStyle} className={'contest-card-strip-gl-title '}>
                  {'Monthly Leaderboard'}
                </Text>
              </View>
            )}
            {isSL && (
              <View style={SLStyle} onPress={onPressLeaderBoard} className="contest-card-strip-gl">
                <Text style={SLTitleStyle} className={'contest-card-strip-gl-title '}>
                  {'SL Leaderboard'}
                </Text>
              </View>
            )}
            {isGL && (
              <View style={GLStyle} onPress={onPressLeaderBoard} className="contest-card-strip-gl">
                <Text style={GLLTitleStyle} className={'contest-card-strip-gl-title '}>
                  {'GL Leaderboard'}
                </Text>
              </View>
            )}
          </View>
        </View>
      )}

      <Card style={contestCardContainerColor} className={'contest-card-container'}>
        <View onPress={_onPressCard} style={{ height: ' 80%' }}>
          <View className="contest-card-left-part" style={contestCardTopSectionStyle}>
            <View className="contest-card-winning-amt-league-container">
              <div className="contest-card-winning-amt-container">
                <Text
                  className="contest-card-winnings-amt"
                  style={boldTextColor}>{`${convertToDollars(winningsAmount / 100)}`}</Text>
                {/* )} */}
                <Text
                  className="contest-card-total-winners"
                  style={totalWinnersColor}>{`${noOfWinner} Winners`}</Text>
              </div>
              {/* {isMatchScheduled && !isFilled && gameType != Constants.GameType.FANTASY_YES_NO && (
                <View
                  style={shareContainer}
                  onPress={_onPressShare}
                  className="contest-card-share-container">
                  <Text style={shareAndEarn} className="contest-card-share-earn-label">
                    {'Share and Earn'}
                  </Text>
                  <img
                    src={
                      themeType === 'dark'
                        ? constants.Images.shareContestIconDark
                        : constants.Images.shareContestIcon
                    }
                    style={{ height: '30px', paddingLeft: '5px', paddingRight: '5px' }}
                  />
                </View>
              )} */}
            </View>
          </View>
          <View className="contest-card-middle-part">
            <View className="contest-card-progress-container">
              <View style={progressWrapperColor} className="contest-card-progress-wrapper">
                <View
                  style={{
                    ...currentProgressColor,
                    width: progressPercentage
                  }}
                  className="contest-card-current-progress"
                />
                {progressPercentage != '0%' && progressPercentage != '100%' && (
                  <View
                    className="contest-card-progress-ball"
                    style={{
                      backgroundColor: theme.contestCardProgressStartColor
                    }}
                  />
                )}
              </View>
              <View
                style={entryFeeWrapperColor}
                className="contest-card-entry-fee-wrapper"
                onPress={_onPressPlayButton}>
                <Text className="contest_card_entry-fee-title" style={boldText1Color}>
                  {`${convertToDollars(entryFee / 100)}`}
                </Text>
              </View>
            </View>
          </View>
          <View className="contest-card-team-left-container">
            <View className="contest-card-fill-spots-wrapper">
              <Text
                style={{ ...fillTeamSlotsColor, fontWeight: 'normal' }}
                className="contest-card-fill-team-slots">{`${filledTeamSlots}/`}</Text>
              <Text
                style={totalSlotsColor}
                className="contest-card-max-player-spots">{`${maximumPlayers} Spots`}</Text>
            </View>
            {acceptsMultipleEntry && (
              <View className="contest-card-max-team-wrapper">
                <Text style={fillTeamSlotsColor} className="contest-card-fill-team-slots">
                  {`${maxTeamPerUser} ${maxTeamPerUser > 1 ? 'Teams/' : 'Team/'}`}
                </Text>
                <Text style={totalSlotsColor} className="contest-card-max-player-spots">
                  {'User'}
                </Text>
              </View>
            )}
          </View>
        </View>
        <View
          className="league-type-container"
          style={{ borderTop: `1px solid ${theme.contestCardBorder}` }}>
          <LeagueType
            isH2HLeague={contestGroupTitle === 'head_to_head'}
            isSingleEntry={contestGroupTitle === 'multiple_player_one_entry'}
            isMultiEntry={contestGroupTitle === 'multiple_player_multiple_entry'}
            istWinner={getIstWinner(formatWinning)}
            isConfirmed={isConfirmed}
            theme={theme}
            bonusPercentage={bonusPercentage}
            minimumPlayers={minimumPlayers}
            isShowMinimumTeams={maximumPlayers != minimumPlayers}
            isGadgetLeague={isGadgetLeague_}
          />
        </View>
      </Card>
    </View>
  );
};
ContestCardWeb.defaultProps = {
  isContestDetails: false
};
export default React.memo(ContestCardWeb);
